import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  GuidedTour,
  GuidedTourService,
  Orientation,
  ProgressIndicatorLocation,
  TourStep,
} from "ngx-guided-tour";
import { takeUntil } from "rxjs";
import { Utils } from "../../utils/utils";
import { VirtualTourService } from "./services/virtual-tour.service";

@Component({
    selector: "pl-virtual-tour",
    templateUrl: "./virtual-tour.component.html",
    styleUrls: ["./virtual-tour.component.scss"],
    standalone: false
})
export class VirtualTourComponent implements OnInit, OnDestroy {
  public tourSteps!: Array<TourStep>;
  public tour!: GuidedTour;
  public active = false;
  public topOfTourBlock: ProgressIndicatorLocation =
    ProgressIndicatorLocation.TopOfTourBlock;
  public backButton!: HTMLButtonElement;

  constructor(
    public tourService: GuidedTourService,
    private readonly virtualTourService: VirtualTourService,
  ) {}

  ngOnInit() {
    this.mountSteps();
  }

  mountSteps() {
    this.tourSteps = [
      {
        selector: "#tour-1 button", // CRIAR NOVO USUÁRIO
        content: `
        <div class="tour-box listing">
          <div class="header">
              <div class="icon-background">
                <div class="icon material-icons-round">person_add</div>
              </div>
              <div class="title">CRIAR NOVO USUÁRIO</div>
          </div>
          <div class="content">
            Aqui você consegue <span>criar um novo usuário espelhando os acessos aos produtos de um usuário já existente.</span>
          </div>
        </div>
      `,
        orientation: Orientation.BottomLeft,
        scrollAdjustment: 4,
      },
      {
        selector: "#tour-2", // PESQUISAR USUÁRIO
        content: `
            <div class="tour-box">
              <div class="header">
              <div class="icon-background">
                <div class="icon material-icons-round">search</div>
              </div>
                <div class="title">PESQUISAR USUÁRIO</div>
              </div>
              <div class="content">
              Aqui você consegue <span>pesquisar usuários pelo logon.</span>
              </div>
            </div>
              `,
        orientation: Orientation.Bottom,
        action: () => {
          this.active = false;
        },
        scrollAdjustment: 350,
        useHighlightPadding: true,
        highlightPadding: 10,
      },
      {
        selector: "#tour-3", // LISTAGEM DE USUÁRIOS
        content: `
            <div class="tour-box listing">
                <div class="header">
                    <div class="icon-background">
                      <div class="icon material-icons-round">list_alt</div>
                    </div>
                    <div class="title">LISTAGEM DE USUÁRIOS</div>
                </div>
                <div class="content">
                  Aqui o sistema disponibiliza todos os usuários dos seus contratos em uma lista paginada. <br/>
                  Nessa lista você consegue visualizar, alguns <span>dados pessoais</span>,
                  o <span>perfil</span>, o <span>status da conta</span> e o <span>status do MFA</span> do usuário.
                </div>
            </div>
              `,
        orientation: Orientation.BottomLeft,
        scrollAdjustment: 400,
      },
      {
        selector: "#tour-4-merged", // STATUS E SEGURANÇA DA CONTA (wrapper gerado dinamicamente para unir Status da conta e Status do MFA)
        content: `
          <div class="tour-box">
            <div class="header">
              <div class="icon-background">
                <div class="icon material-icons-round">verified</div>
              </div>
              <div class="title">STATUS E SEGURANÇA DA CONTA</div>
            </div>
            <div class="content">
              <b>Status da conta:</b> mostra se a conta está ativa, bloqueada, excluída ou inativa.<br/>
              <b>Status do MFA:</b> indica se a conta tem proteção extra além da senha está ativada.
            </div>
          </div>
        `,
        orientation: Orientation.Left,
        scrollAdjustment: 350,
      },
      {
        selector: "#tour-5", // PERFIS DE USUÁRIOS
        content: `
          <div class="tour-box">
  <div class="header">
    <div class="icon-background">
      <div class="icon material-icons-round">group</div>
    </div>
    <div class="title">PERFIS DE USUÁRIOS</div>
  </div>
  <div class="content">
  Além do perfil <span>Usuário</span>, há três perfis que ajudam a gerenciar acessos com segurança.<br/><br/>
  O <span>Responsável pelo Contrato</span>, junto com o <span>Gestor de Acessos</span>, pode fazer alterações cadastrais, financeiras e de acesso. Já o <span>Administrador de Acessos</span> dá suporte exclusivamente pelo Portal de Logons.
  </div>
</div>
              `,
        orientation: Orientation.Left,
        action: () => {
          this.active = false;
        },
        scrollAdjustment: 350,
      },
      {
        selector: "#tour-6", // AÇÕES
        content: `
          <div class="tour-box">
            <div class="header">
            <div class="icon-background">
              <div class="icon material-icons-round">more_vert</div>
          </div>
              <div class="title">AÇÕES</div>
            </div>
            <div class="content">
              Cada usuário na lista possui um ícone de Ações, no qual você consegue acessar as funcionalidades de
              <span>Visualização dos dados, Edição, Bloqueio/Desbloqueio e Redefinição de senha</span> do usuário.
            </div>
          </div>
              `,
        orientation: Orientation.Left,
        action: () => {
          this.active = true;
        },
        scrollAdjustment: 350,
      },
      {
        selector: "#tour-7", // VISUALIZAR DADOS DO USUÁRIO
        content: `
            <div class="tour-box">
            <div class="header">
            <div class="icon-background">
              <div class="icon material-icons-round">person_search</div>
            </div>
              <div class="title">VISUALIZAR DADOS DO USUÁRIO</div>
            </div>
            <div class="content">
              Aqui você consegue acessar os dados completos do usuário selecionado, assim como <span>os motivos de um possível status de bloqueio ou de pendência.</span>
            </div>
          </div>
              `,
        orientation: Orientation.Left,
        action: () => {
          this.active = true;
        },
        scrollAdjustment: 350,
      },
      {
        selector: "#tour-8", // EDITAR USUÁRIO
        content: `
        <div class="tour-box">
          <div class="header">
          <div class="icon-background">
            <div class="icon material-icons-round">edit</div>
          </div>
            <div class="title">EDITAR USUÁRIO</div>
          </div>
          <div class="content">
          Aqui você consegue <span>editar os dados pessoais</span> do usuário selecionado.
          </div>
      </div>`,
        orientation: Orientation.Left,
        scrollAdjustment: 350,
      },
      {
        selector: "#tour-9", // REDEFINIR A SENHA DO USUÁRIO
        content: `
            <div class="tour-box">
              <div class="header">
              <div class="icon-background">
                <div class="icon material-icons-round">lock_reset</div>
              </div>
                <div class="title">REDEFINIR A SENHA DO USUÁRIO</div>
              </div>
              <div class="content">
                Aqui você consegue <span>redefinir a senha</span> do usuário selecionado.
              </div>
            </div>
              `,
        orientation: Orientation.Left,
        scrollAdjustment: 350,
      },
      {
        selector: "#tour-10", // BLOQUEAR USUÁRIO
        content: `
        <div class="tour-box">
          <div class="header">
          <div class="icon-background">
            <div class="icon material-icons-round">no_accounts</div>
          </div>
            <div class="title">BLOQUEAR USUÁRIO</div>
          </div>
          <div class="content">
            Aqui você consegue <span>bloquear</span> e <span>desbloquear</span> o usuário selecionado.
          </div>
        </div>
              `,
        orientation: Orientation.Left,
        scrollAdjustment: 350,
      },
      {
        selector: "#tour-11", // EXCLUIR USUÁRIO
        content: `
        <div class="tour-box">
          <div class="header">
          <div class="icon-background">
            <div class="icon material-icons-round">delete</div>
          </div>
            <div class="title">EXCLUIR USUÁRIO</div>
          </div>
          <div class="content">
            Aqui você consegue <span>excluir</span> o usuário selecionado.
          </div>
        </div>
              `,
        orientation: Orientation.Left,
        action: () => {
          this.active = true;
        },
        scrollAdjustment: 350,
      },
    ];

    this.callInitTour();
  }

  public callInitTour(): void {
    this.tour = {
      tourId: "logon-portal-tour",
      useOrb: false,
      completeCallback: () => this.updateTour(),
      skipCallback: () => this.updateTour(),
      steps: this.tourSteps,
      preventBackdropFromAdvancing: true,
    };

    setTimeout(() => {
      this.resetScroll();
      this.setClassForOverflowHidden();
      this.createMergedStatusHighlight();
      this.tourService.startTour(this.tour);
    }, 1000);
  }

  public updateTour(): void {
    this.resetScroll();
    this.setClassForOverflowHidden(false);
    this.virtualTourService.isOnTour.next(false);
    this.virtualTourService
      .flagTourAsDone()
      .pipe(takeUntil(Utils.componentDestroyed(this)))
      .subscribe();
    document.getElementById("tour-4-merged")?.remove();
  }

  public setClassForOverflowHidden = (add = true): void => {
    if (add) {
      document.querySelector("body")?.classList.add("no-scrolling");
    } else {
      document.querySelector("body")?.classList.remove("no-scrolling");
    }
  };

  public getNgxElement = (): NodeListOf<HTMLButtonElement> => {
    return document.querySelectorAll("ngx-guided-tour");
  };

  public resetScroll = (): void => {
    document.querySelector("html")?.scrollTo(0, 0);
  };

  public createRepeatButtonAndRemoveSkip = () => {
    const tourButtonsContainer = document.querySelector(".tour-buttons");
    const repeatTourButton$ = document.createElement("button");
    const skipButton = document.querySelector(
      ".skip-button",
    ) as HTMLButtonElement;

    this.backButton = document.querySelector(
      ".back-button",
    ) as HTMLButtonElement;

    repeatTourButton$.classList.add("repeat-tour-button");
    repeatTourButton$.classList.add("back-button");
    repeatTourButton$.classList.add("link-button");

    repeatTourButton$.innerHTML = "Repetir tour";
    repeatTourButton$.onclick = () => {
      this.repeatTour();
    };

    tourButtonsContainer?.appendChild(repeatTourButton$);
    tourButtonsContainer?.removeChild(this.backButton);
    skipButton.classList.add("invisible");
  };

  public repeatTour() {
    const tourButtonsContainer = document.querySelector(".tour-buttons");

    const skipButton = document.querySelector(
      ".skip-button",
    ) as HTMLButtonElement;
    const repeatTourButton = document.querySelector(
      ".repeat-tour-button",
    ) as Node;

    tourButtonsContainer?.removeChild(repeatTourButton);
    tourButtonsContainer?.appendChild(this.backButton);

    this.tourService.resetTour();
    this.tourService.startTour(this.tour);

    skipButton.classList.remove("invisible");
    this.createMergedStatusHighlight();
  }

  private createMergedStatusHighlight(): void {
    if (document.getElementById("tour-4-merged")) return;

    const statusContaEl = document.getElementById("tour-4");
    const statusMfaEl = document.getElementById("tour-4-1");
    if (!statusContaEl || !statusMfaEl) return;

    const rect1 = statusContaEl.getBoundingClientRect();
    const rect2 = statusMfaEl.getBoundingClientRect();

    const top = Math.min(rect1.top, rect2.top) + window.scrollY;
    const left = Math.min(rect1.left, rect2.left) + window.scrollX;
    const right = Math.max(rect1.right, rect2.right) + window.scrollX;
    const bottom = Math.max(rect1.bottom, rect2.bottom) + window.scrollY;

    const wrapper = document.createElement("div");
    wrapper.id = "tour-4-merged";
    Object.assign(wrapper.style, {
      position: "absolute",
      top: `${top}px`,
      left: `${left}px`,
      width: `${right - left}px`,
      height: `${bottom - top}px`,
      zIndex: "9999",
      pointerEvents: "none",
    });

    document.body.appendChild(wrapper);
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnDestroy() {
    // This is intentional for takeUntil use
  }
}
